import React from 'react'

const Loading = () => (
    // <div className="indicator" style={{ width: '100%', height: '100%', top: 0, left: 0 }}>
    //     <div className="load">
    //         <hr />
    //         <hr />
    //         <hr />
    //         <hr />
    //     </div>
    // </div>

    //     <div className="loading">
    //   <div>
    //     <div className="c1"></div>
    //     <div className="c2"></div>
    //     <div className="c3"></div>
    //     <div className="c4"></div>
    //   </div>
    //   <span>loading</span>
    // </div>
    <div className="blur" style={{ width: '100%', height: '100%', top: 0, left: 0, position: 'absolute' }}>

    </div>
);

export default Loading;